var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftsidetwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 162,
    viewBox: "0 0 56 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M51.1668 51.2144L-49.3193 157.692C-47.6166 158.313 -45.898 158.873 -44.1602 159.356L52.737 56.6811C52.2812 54.8397 51.7525 53.0186 51.1668 51.2144Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M47.1485 41.2139L-58.7578 153.435C-57.2561 154.256 -55.73 155.016 -54.1797 155.715L49.2998 46.0649C48.6381 44.4254 47.921 42.8084 47.1485 41.2139Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M53.9482 62.5254L-38.6445 160.637C-36.6901 161.011 -34.7217 161.302 -32.7394 161.51L54.7724 68.7827C54.5759 66.6831 54.3011 64.5973 53.9482 62.5254Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M42.0645 32.3442L-67.1279 148.048C-65.7989 149.044 -64.4394 149.977 -63.0593 150.866L44.7233 36.6554C43.8852 35.1931 43.0047 33.7525 42.0645 32.3442Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M-26.3843 161.907C-24.0767 161.943 -21.7631 161.875 -19.4502 161.689L54.9388 82.8641C55.115 80.4126 55.1786 77.9618 55.1449 75.5166L-26.3843 161.907Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M-2.89122 158.401L51.8339 100.413C52.7098 97.3344 53.4176 94.2049 53.954 91.04L-11.7354 160.646C-8.7491 160.078 -5.79617 159.329 -2.89122 158.401Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M36.0135 24.4961L-74.5332 141.636C-73.3652 142.794 -72.1772 143.914 -70.9555 144.971L39.1572 28.2927C38.1634 26.9939 37.1067 25.7345 36.0135 24.4961Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M31.3202 136.662C38.0995 129.492 43.6418 121.12 47.696 111.925L7.97656 154.015C16.6538 149.718 24.5543 143.845 31.3202 136.662Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M21.1787 11.7031L-86.6079 125.914C-85.7691 127.376 -84.8853 128.816 -83.9485 130.225L25.2453 14.5211C23.9149 13.5256 22.5554 12.5919 21.1787 11.7031Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M2.27673 3.21484L-94.6191 105.888C-94.164 107.731 -93.6346 109.551 -93.0503 111.355L7.4352 4.87657C5.73449 4.25737 4.01588 3.69714 2.27673 3.21484Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M29.0703 17.5972L-81.0425 134.276C-80.0434 135.573 -78.9886 136.833 -77.8948 138.071L32.6506 20.9326C31.4832 19.7756 30.294 18.6558 29.0703 17.5972Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M12.295 6.854L-91.1831 116.505C-90.5206 118.143 -89.8035 119.76 -89.0319 121.355L16.8744 9.13563C15.3714 8.31284 13.8449 7.5523 12.295 6.854Z",
    fill: "#474A88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftsidetwo);
export default __webpack_public_path__ + "static/media/leftsidetwo.02dd6c1fc2891789ead5fbccd950c35e.svg";
export { ForwardRef as ReactComponent };